module.exports = __webpack_public_path__ + "static/media/map_polluted_soil.ae977325.png";


//////////////////
// WEBPACK FOOTER
// ./public/pictures/markers/map_polluted_soil.png
// module id = 2232
// module chunks = 0